import { render } from "./ParallaxBigImage.vue?vue&type=template&id=41e28c8e&scoped=true"
import script from "./ParallaxBigImage.vue?vue&type=script&lang=js"
export * from "./ParallaxBigImage.vue?vue&type=script&lang=js"

import "./ParallaxBigImage.vue?vue&type=style&index=0&id=41e28c8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41e28c8e"]])

export default __exports__